export const CloseIcon = ({ width = "24", height = "24", className }: { width?: string, height?: string, className?: string }) => {
    return (
        <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
            <g>
                <mask id="mask0" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                    <rect width="24" height="24" fill="#D9D9D9" />
                </mask>
                <g mask="url(#mask0)">
                    <path
                        d="M12.0251 13.85L7.2501 18.65C6.98343 18.9167 6.66676 19.0458 6.3001 19.0375C5.93343 19.0292 5.61676 18.8917 5.3501 18.625C5.1001 18.3583 4.97926 18.05 4.9876 17.7C4.99593 17.35 5.1251 17.0417 5.3751 16.775L10.1251 12L5.3501 7.17499C5.1001 6.90832 4.9751 6.59999 4.9751 6.24999C4.9751 5.89999 5.1001 5.59165 5.3501 5.32499C5.61676 5.05832 5.93343 4.92082 6.3001 4.91249C6.66676 4.90415 6.98343 5.03332 7.2501 5.29999L12.0251 10.1L16.7501 5.29999C17.0168 5.03332 17.3334 4.90415 17.7001 4.91249C18.0668 4.92082 18.3834 5.05832 18.6501 5.32499C18.9001 5.59165 19.0209 5.89999 19.0126 6.24999C19.0043 6.59999 18.8751 6.90832 18.6251 7.17499L13.8751 12L18.6251 16.775C18.8751 17.025 19.0043 17.3292 19.0126 17.6875C19.0209 18.0458 18.9001 18.3583 18.6501 18.625C18.3834 18.8917 18.0668 19.0292 17.7001 19.0375C17.3334 19.0458 17.0168 18.9167 16.7501 18.65L12.0251 13.85Z"
                        fill="currentColor"
                    />
                </g>
            </g>
        </svg>
    );
}

